import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=57881754&scoped=true&"
import script from "./ProjectPage.vue?vue&type=script&lang=js&"
export * from "./ProjectPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=57881754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57881754",
  null
  
)

export default component.exports